import { CIcon, IconSelector } from "@utils/icons";
import { TW_IconPickerButton, TW_IconPickerPopoverContent, TW_IconPickerTrigger } from "@utils/twClasses";
import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { CompozzIcon } from "@dto/CompozzIcon";

interface IconPickerProps {
    icon: CompozzIcon;
    color: string;
    side?: "top" | "right" | "bottom" | "left";
    align?: "center" | "start" | "end";
    sideOffset?: number;
    onChange: (icon: CompozzIcon) => void;
}
    
export function IconPicker({ icon, color, onChange, side="right", align="center", sideOffset=4 }: IconPickerProps) {

    const [isIconSelectorOpen, setIsIconSelectorOpen] = useState(false);


    const changeIcon = (icon: CompozzIcon) => {
        onChange(icon);
        setIsIconSelectorOpen(false);
    }


    function handleBlur(e: React.FocusEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
    }

    return (
        <Popover open={isIconSelectorOpen} onOpenChange={setIsIconSelectorOpen} modal>
            <PopoverTrigger className={TW_IconPickerTrigger}>
                <CIcon compozzIcon={icon} color={color} className={TW_IconPickerButton}/>
            </PopoverTrigger>
            <PopoverContent className={TW_IconPickerPopoverContent} side={side} align={align} sideOffset={sideOffset} onBlur={(e) => handleBlur(e)} >
                <IconSelector icon={icon} color={color} onChange={changeIcon}/>
            </PopoverContent>
        </Popover>
    )
}